export const QrCodeReaderTranslation = {
  en: {
    errorToast: 'Could not open camera. Please try again.'
  },
  pt: {
    errorToast: 'Não foi possível abrir a câmera. Tente novamente.'
  }
}
